import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import BtnLoad from "../components/common/BtnLoad";
import ModuleBasicDetails from "../components/ModuleBasicDetails/ModuleBasicDetails";
import Tasklist from "../components/tasklist/Tasklist";
import ModuleUploadAssets from "../components/moduleUploadAssets/ModuleUploadAssets";
import { useParams } from "react-router-dom";
import ModuleAnalytics from "../components/moduleAnalytics/ModuleAnalytics";

const BASIC_DETAILS = "groups";
const UPLOAD_ASSETS = "upload_assets";
const TASK_LIST = "tasklist";
const ANALYTICS = "analytics";

const MCreation = () => {
  const [activeTab, setActiveTab] = useState(BASIC_DETAILS);
  const { id } = useParams();

  return (
    <div className="creationPage">
      <div className="page-title">
        <div className="col-md-6">
          <h6>Add Module Details</h6>
        </div>
      </div>
      <Tab.Container id="module-tabs" activeKey={activeTab} onSelect={setActiveTab}>
        <div className="title-mini">
          <div className="nav-option">
            <Nav className="tabfull tabsproduct" variant="pills">
              <Nav.Item>
                <Nav.Link eventKey={BASIC_DETAILS}>Basic Details</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={UPLOAD_ASSETS}>Upload Assets</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={TASK_LIST}>Tasklist</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link eventKey={ANALYTICS}>Analytics</Nav.Link>
              </Nav.Item> */}
            </Nav>
          </div>
          {/* <div className="modalFooterB">
            <button className="cancel">Cancel</button>
            <button className="save">{loading ? <BtnLoad /> : "Add"}</button>
          </div> */}
        </div>
        <Tab.Content>
          <Tab.Pane eventKey={BASIC_DETAILS}>
            <ModuleBasicDetails id={id} />
          </Tab.Pane>
          <Tab.Pane eventKey={UPLOAD_ASSETS}>
            <ModuleUploadAssets id={id} />
          </Tab.Pane>
          <Tab.Pane eventKey={TASK_LIST}>
            <Tasklist />
          </Tab.Pane>
          <Tab.Pane eventKey={ANALYTICS}>
            <ModuleAnalytics />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default MCreation;

const ComponentOne = () => {
  console.log("Component 1");
  return <div></div>;
};

const ComponentTwo = () => {
  console.log("Component 2");
  return <div></div>;
};
